import axios from "axios";
import authHeader from "./services";
import { useMutation, useQuery, useQueryClient } from "react-query";
// import  getConfig  from 'next/config'

// Only holds serverRuntimeConfig and publicRuntimeConfig

const queryString = require("querystring");

// const { serverRuntimeConfig, publicRuntimeConfig } = getConfig()

import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();

export const api = axios.create({
  baseURL: publicRuntimeConfig.API_URL,
  // baseURL: 'https://qa-api.idonatio.com/api/v1'
});

export const regApi = axios.create({
  baseURL: publicRuntimeConfig.API_URL,
  // baseURL: 'https://qa-api.idonatio.com/api/v1'
});

api.interceptors.request.use(function (config) {
  const token = sessionStorage.getItem("token");
  config.headers.Authorization = token ? `Bearer ${token}` : "";
  return config;
});

regApi.interceptors.request.use(function (config) {
  const token = sessionStorage.getItem("reg");
  config.headers.Authorization = token ? `Bearer ${token}` : "";
  return config;
});

//User end points

export const subscribe = (finalResponse) => {
  return regApi.patch("/donees/onboard", finalResponse);
};

export const getSes = () => {
  return regApi.get("/aws/temp-credentials");
};

export const signOut = () => {
  return api.post("/auth/logout");
};

export const supports = (data) => {
  return api.post("/supports", data);
};

export const getDonations = (queryString) => {
  return api.get(`/donations${queryString ? `?${queryString}` : " "}`);
};

export const getUnclaimedPlatesDonations = (queryString) => {
  return api.get(
    `/donations/unclaimed-plates${queryString ? `?${queryString}` : " "}`,
  );
};

export const getOtherIncome = (queryString) => {
  return api.get(`/other-incomes${queryString ? `?${queryString}` : " "}`);
};

export const getRefundHistory = (queryString) => {
  return api.get(`/donations/${queryString}/refunds`);
};

export const getDonorRefunds = (queryString) => {
  return api.get(`/donors/${queryString}/refunds`);
};

export const getDonorHistory = (queryString) => {
  return api.get(`/donors/${queryString}/donations?is_anonymous=false`);
};

export const getEvents = (queryString) => {
  return api.get(`/events`);
};

export const makeEvents = (data) => {
  return api.post(`/events`, data);
};

export const editEvents = ({ id, values }) => {
  return api.patch(`/events/${id}`, values);
};

export const deleteEvents = (data) => {
  return api.delete(`/events/${data.id}`, data);
};

export const getAllRefunds = (queryString) => {
  return api.get(`/refunds${queryString ? `?${queryString}` : " "}`);
};

export const getDonationsSummary = (queryString) => {
  return api.get(`/donations/summary${queryString ? `?${queryString}` : " "}`);
};

export const getPlateDonationsSummary = (queryString) => {
  return api.get(
    `/donations/plate-donations-summary${queryString ? `?${queryString}` : " "}`,
  );
};

export const getOtherIncomeSummary = (queryString) => {
  return api.get(
    `/other-incomes/summary${queryString ? `?${queryString}` : " "}`,
  );
};

export const register = (data) => {
  return regApi.post("/donees", data);
};

export const refund = (data) => {
  return api.post(`/donations/${data.id}/refunds`, {
    donation_id: data.donation_id,
    donation_details: data.donation_details,
  });
};

export const claim = (data) => {
  return api.post(`/gift-aids/claims/automatic`, data);
};

export const automaticClaim = (data) => {
  return api.post(`/gift-aids/automatic/claim`, data);
};

export const otherGiftAid = (query) => {
  return api.get(`/gift-aids/other-donations?${query}`);
};

export const updateAcknowledgement = (data) => {
  return api.patch(`/acknowledgment-emails`, data);
};

export const RegUser = () => {
  return regApi.get("/auth/user");
};

export const getUser = () => {
  const token = sessionStorage.getItem("token");
  const RegToken = sessionStorage.getItem("reg");
  return axios.get(`${publicRuntimeConfig.API_URL}/auth/user`, {
    headers: {
      Authorization: token
        ? `Bearer ${token}`
        : RegToken
          ? `Bearer ${RegToken}`
          : "",
    },
  });
};

export const resendOtp = () => {
  return regApi.get("/auth/otp/resend");
};

export const getGiftAid = (query) => {
  return api.get(`/gift-aids?${query}`);
};

export const getConfigs = () => {
  return api.get("/configs/fees");
};

export const delDonnee = () => {
  return api.delete("/donees/settings/profile");
};

export const delOrganization = () => {
  return api.delete("/donees/settings/organization");
};

export const delDonType = (data) => {
  return api.delete(`/donation-types/${data}`);
};

export const getStripeLogin = (queryString) => {
  const token = sessionStorage.getItem("token");
  const RegToken = sessionStorage.getItem("reg");
  return axios.get(
    `${publicRuntimeConfig.API_URL}/stripe/accounts/login${
      queryString ? `?${queryString}` : " "
    }`,
    {
      headers: {
        Authorization: token
          ? `Bearer ${token}`
          : RegToken
            ? `Bearer ${RegToken}`
            : "",
      },
    },
  );
};

export const getStripeOtp = (queryString) => {
  return api.get(
    `/stripe/accounts/login${queryString ? `?otp=${queryString}` : " "}`,
  );
};

export const resendValidation = (data) => {
  return api.get(`/donees/settings/users/${data}/resend-password`);
};

export const authenticatePassword = (data) => {
  return api.post(`/auth/password/validate`, data);
};

export const login = (data) => {
  return api.post("/auth/login", data);
};

export const updateUser = (data) => {
  return api.patch("/donees/settings/users/" + data.user_id, data);
};

export const deleteUser = (data) => {
  return api.delete("/donees/settings/users/" + data.user_id);
};

export const verify = ({ form }) => {
  return regApi.post("/auth/verify/email", { otp: form });
};

export const editProfile = (data) => {
  return api.patch("/donees/settings/profile", data);
};

export const editOrganization = (data) => {
  return api.patch("/donees/settings/organization", data);
};

export const editPlatform = (data) => {
  return api.patch("/donees/settings/platform", data);
};

export const sendOtp = (data) => {
  return axios.post(
    `${publicRuntimeConfig.API_URL}/auth/password/forgot`,
    data,
  );
};

export const resetPassword = (data) => {
  return axios.patch(
    `${publicRuntimeConfig.API_URL}/auth/password/reset`,
    data,
  );
};

export const makeUser = (data) => {
  return api.post("/donees/settings/users", data);
};

export const contact = (data) => {
  return api.post("/public/contact-us", data);
};

export const checkOtp = (data) => {
  return axios.patch(
    `${publicRuntimeConfig.API_URL}/auth/password/validate-otp`,
    data,
  );
};

export const editDonationType = ({ id, values }) => {
  return api.patch(`/donation-types/${id}`, values);
};

export const createDonationType = (data) => {
  return api.post(`/donation-types`, data);
};

export const AddDonationRecord = (data) => {
  return api.post(`/donations`, data);
};

export const changePassword = (data) => {
  return axios.patch(
    `${publicRuntimeConfig.API_URL}/auth/password/change-password`,
    data,
  );
};

export const changeLoggedInPassword = (data) => {
  return api.patch(`/auth/password/change-password`, data);
};

// export const getDonorsFilter = () => {
//   return api.get("/donors");
// };

export const getDonationTypes = () => {
  return api.get("/donation-types");
};

export const getUKLocalAuthorityAreas = () => {
  return api.get("/dashboard/donees/uk-local-authorities");
};

export const getDashboardDonationTypes = (period) => {
  return api.get("/dashboard/donees/donation-types?duration=" + period);
};

export const getDashboardGiftAid = (period) => {
  return api.get("/dashboard/donees/gift-aids?duration=" + period);
};
export const getDashboardTransaction = (period) => {
  return api.get("/dashboard/donees/transaction-fees?duration=" + period);
};

export const getRefundSummary = () => {
  return api.get("/refunds/summary");
};

export const getClaimSummary = (
  first_date,
  second_date,
  gasds_from,
  gasds_to,
  from_page,
) => {
  return api.get(
    `/gift-aids/summary?date_from=${first_date}&date_to=${second_date}&gasds_from=${gasds_from}&gasds_to=${gasds_to}&from_page=${from_page}`,
  );
};

export const getClaimData = (data) => {
  return api.post(`/gift-aids/new-summary`, data);
  // return api.get(`/gift-aids/new-summary?date_from=${first_date}&date_to=${second_date}&gasds_from=${gasds_from}&gasds_to=${gasds_to}&from_page=${from_page}`);
};

export const getDashboardDonors = (period) => {
  return api.get("/dashboard/donees/donors?duration=" + period);
};

export const getDashboardDonations = (period) => {
  return api.get("/dashboard/donees/donations?duration=" + period);
};

export const getDashboardGraph = (period) => {
  return api.get("/dashboard/donees/graphs?duration=" + period);
};

export const getCharities = (query) => {
  return api.get(`/charities?${query}`);
};

export const getRoles = () => {
  return api.get(`/roles?category=donee`);
};

export const getStripeLink = (query) => {
  const token = sessionStorage.getItem("token");
  const RegToken = sessionStorage.getItem("reg");
  return axios.get(`${publicRuntimeConfig.API_URL}/stripe/accounts/links`, {
    headers: {
      Authorization: token
        ? `Bearer ${token}`
        : RegToken
          ? `Bearer ${RegToken}`
          : "",
    },
  });
};

export const getDonationType = (id) => {
  return api.get(`/donation-types/${id}`);
};

export const getDonors = (queryString) => {
  return api.get(`/donors${queryString ? `?${queryString}` : " "}`);
};
export const getUsers = () => {
  return api.get(`/donees/settings/users`);
};

export const getDonorsFiltered = (params) => {
  return api.get(`/donors?${params}`);
};

export const getDonorsSummary = () => {
  return api.get(`/donors/summary`);
};

export const getAcknowledgement = () => {
  return api.get(`/acknowledgment-emails`);
};

export const getCountries = () => {
  return api.get(`/countries`);
};

export const getGiftAidAggregate = (query) => {
  return api.get(`/gift-aids/aggregate?${query}`);
};

export const onGetGiftAidAggregate = (query) => {
  return useQuery(["getGiftAidAggregate", query], () =>
    getGiftAidAggregate(query),
  );
};

export const onGetGiftAidOtherAggregate = (query) => {
  return useQuery(["otherGiftAidAggregate", query], () =>
    otherGiftAidAggregate(query),
  );
};

export const otherGiftAidAggregate = (query) => {
  return api.get(`/gift-aids/other-donations/aggregate?${query}`);
};

//donations page
export const onGetDonations = (queryString) => {
  return useQuery(["getDonations", queryString], () =>
    getDonations(queryString),
  );
};

export const onGetUnclaimedPlatesDonations = (queryString) => {
  return useQuery(["getUnclaimedPlatesDonations", queryString], () =>
    getUnclaimedPlatesDonations(queryString),
  );
};

export const onGetCountries = () => {
  return useQuery("getCountries", getCountries);
};

export const onGetOtherGiftAid = (query) => {
  return useQuery(["otherGiftAid", query], () => otherGiftAid(query));
};

export const onGetOtherIncome = (queryString) => {
  return useQuery(["getOtherIncome", queryString], () =>
    getOtherIncome(queryString),
  );
};

export const onResendValidation = () => {
  return useMutation(resendValidation);
};

export const onGetUsers = () => {
  return useQuery("getUsers", getUsers);
};
export const onGetStripeLogin = (isNotAdmin) => {
  return useQuery("getStripeLogin", () => getStripeLogin(), {
    enabled: isNotAdmin,
  });
};

export const onGetEvents = () => {
  return useQuery("getEvents", getEvents);
};

export const onGetClaimSummary = (
  first_date,
  second_date,
  gasds_from,
  gasds_to,
  from_page,
) => {
  return useQuery(
    [
      "getClaimSummary",
      first_date,
      second_date,
      gasds_from,
      gasds_to,
      from_page,
    ],
    () =>
      getClaimSummary(first_date, second_date, gasds_from, gasds_to, from_page),
  );
};

export const onGetClaimData = (data) => {
  return useQuery(["getClaimData", data], () => getClaimData(data), {
    enabled: false,
  });
};

export const onGetStripeOtp = (isNotAdmin, otp) => {
  return useQuery(["getStripeOtp", otp], () => getStripeOtp(otp), {
    enabled: isNotAdmin,
    retry: 0,
  });
};

export const onGetRoles = () => {
  return useQuery("getRoles", getRoles);
};

export const onGetSes = () => {
  return useQuery("getRoles", getSes);
};

export const onGetAcknowledgement = () => {
  return useQuery("getAcknowledgement", getAcknowledgement);
};

export const onGetCharities = (queryString) => {
  return useQuery(
    ["getCharities", queryString],
    () => getCharities(queryString),
    {
      enabled: !!queryString,
    },
  );
};

export const onGetDonationsSummary = (queryString) => {
  return useQuery(["getDonationsSummary", queryString], () =>
    getDonationsSummary(queryString),
  );
};

export const onGetPlateDonationsSummary = (queryString) => {
  return useQuery(["getPlateDonationsSummary", queryString], () =>
    getPlateDonationsSummary(queryString),
  );
};

export const onGetOtherIncomeSummary = (queryString) => {
  return useQuery(["getOtherIncomeSummary", queryString], () =>
    getOtherIncomeSummary(queryString),
  );
};

export const onGetGiftAid = (query) => {
  return useQuery(["getGiftAid", query], () => getGiftAid(query));
};

//donations types page
export const onGetDonationTypes = () => {
  return useQuery("getDonationTypes", getDonationTypes);
};

export const onGetUKLocalAuthorityAreas = () => {
  return useQuery("getUKLocalAuthorityAreas", getUKLocalAuthorityAreas);
};

export const onGetRefundSumary = () => {
  return useQuery("getRefundSummary", getRefundSummary);
};

export const onGetDonationType = (id) => {
  return useQuery(["getDonationType", id], () => getDonationType(id), {
    enabled: !!id,
  });
};

export const onGetUser = (pathIsNotPublic = true) => {
  return useQuery("getUser", getUser, {
    enabled: pathIsNotPublic,
  });
};

export const onGetRegUser = (pathIsNotPublic = true) => {
  return useQuery("getUser", RegUser, {
    enabled: pathIsNotPublic,
  });
};

export const onGetConfigs = () => {
  return useQuery("getConfigs", getConfigs);
};

export const onGetDonors = (queryString) => {
  return useQuery(["getDonorRecords", queryString], () =>
    getDonors(queryString),
  );
};

export const onGetRefunds = (params) => {
  return useQuery(["getRefunds", params], () => getAllRefunds(params));
};

export const onGetDonorsFiltered = (params) => {
  return useQuery(["getDonors", params], () => getDonorsFiltered(params), {
    enabled: !!params,
  });
};

export const onGetDonorsSummary = () => {
  return useQuery("getDonorsSummary", getDonorsSummary);
};

export const onGetDashboardDonors = (period) => {
  return useQuery(["getDashboardDonors", period], () =>
    getDashboardDonors(period),
  );
};

export const onGetDashboardTransaction = (period) => {
  return useQuery(["getDonorsTransactions", period], () =>
    getDashboardTransaction(period),
  );
};

export const onGetDashboardDonations = (period) => {
  return useQuery(["getDashboardDonations", period], () =>
    getDashboardDonations(period),
  );
};

export const onGetDashboardGraph = (period) => {
  return useQuery(["getDashboardGraph", period], () =>
    getDashboardGraph(period),
  );
};
export const onGetDashboardGiftAid = (period) => {
  return useQuery(["getDashboardGiftAid", period], () =>
    getDashboardGiftAid(period),
  );
};
export const onGetDashboardDonationTypes = (period) => {
  return useQuery(["getDashboardDonationTypes", period], () =>
    getDashboardDonationTypes(period),
  );
};

export const onGetRefundHistory = (donation_id) => {
  return useQuery(["getRefundHistory", donation_id], () =>
    getRefundHistory(donation_id),
  );
};

export const onGetDonorRefunds = (donor_id) => {
  return useQuery(["getDonorRefunds", donor_id], () =>
    getDonorRefunds(donor_id),
  );
};

export const onGetDonorHistory = (donor_id) => {
  return useQuery(["getDonorHistory", donor_id], () =>
    getDonorHistory(donor_id),
  );
};

export const onResendOtp = (enabled) => {
  return useQuery("resend", resendOtp, {
    enabled,
  });
};

export const onGetStripeLink = () => {
  return useQuery("getStripeLink", getStripeLink);
};

export const onBoard = () => {
  const queryClient = useQueryClient();
  return useMutation(subscribe, {
    onSuccess: () => {
      queryClient.invalidateQueries("getUser");
    },
  });
};

export const onEditEvents = () => {
  const queryClient = useQueryClient();
  return useMutation(editEvents, {
    onSuccess: () => {
      queryClient.invalidateQueries("getEvents");
    },
  });
};

export const onDeleteEvents = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteEvents, {
    onSuccess: () => {
      queryClient.invalidateQueries("getEvents");
    },
  });
};

export const onMakeEvents = () => {
  const queryClient = useQueryClient();
  return useMutation(makeEvents, {
    onSuccess: () => {
      queryClient.invalidateQueries("getEvents");
    },
  });
};

export const onSignOut = () => {
  const queryClient = useQueryClient();
  return useMutation(signOut, {
    onSuccess: () => {
      queryClient.invalidateQueries("getUser");
    },
  });
};

export const onUpdateAcknowledgements = () => {
  return useMutation(updateAcknowledgement);
};

export const onMakeClaim = () => {
  return useMutation(claim);
};

export const onSubmitClaim = () => {
  return useMutation(automaticClaim);
};

export const onContact = () => {
  return useMutation(contact);
};

export const onGetSupport = () => {
  return useMutation(supports);
};

export const onAuthPassword = () => {
  return useMutation(authenticatePassword);
};

export const onDelDonType = () => {
  const queryClient = useQueryClient();
  return useMutation(delDonType, {
    onSuccess: () => {
      queryClient.invalidateQueries("getDonationTypes");
    },
  });
};

export const onDelDonnee = () => {
  return useMutation(delDonnee);
};

export const onDelOrganization = () => {
  return useMutation(delOrganization);
};

export const onMakeUser = () => {
  const queryClient = useQueryClient();
  return useMutation(makeUser, {
    onSuccess: () => {
      queryClient.invalidateQueries("getUsers");
    },
  });
};

export const onUpdateUser = () => {
  const queryClient = useQueryClient();
  return useMutation(updateUser, {
    onSuccess: () => {
      queryClient.invalidateQueries("getUsers");
    },
  });
};

export const onDeleteUser = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteUser, {
    onSuccess: () => {
      queryClient.invalidateQueries("getUsers");
    },
  });
};
export const onRegister = () => {
  // const queryClient = useQueryClient()
  return useMutation(register);
};

export const onCreateDonation = () => {
  const queryClient = useQueryClient();
  return useMutation(createDonationType, {
    onSuccess: () => {
      queryClient.invalidateQueries("getDonationTypes");
      queryClient.invalidateQueries("getDonationType");
    },
  });
};

export const onAddDonationRecord = () => {
  const queryClient = useQueryClient();
  return useMutation(AddDonationRecord, {
    onSuccess: () => {
      queryClient.invalidateQueries("getRefundHistory");
      queryClient.invalidateQueries("getDonations");
      queryClient.invalidateQueries("getDonors");
      queryClient.invalidateQueries("getDonorRecords");
      queryClient.invalidateQueries("getDonorsTransactions");
      queryClient.invalidateQueries("getDonors");
      queryClient.invalidateQueries("getDonationsSummary");
      queryClient.invalidateQueries("getOtherIncomeSummary");
      queryClient.invalidateQueries("getOtherIncome");
      queryClient.invalidateQueries("getRefundSummary");
      queryClient.invalidateQueries("getDonorsSummary");
      queryClient.invalidateQueries("getDonationTypes");
      queryClient.invalidateQueries("getDashboardDonors");
      queryClient.invalidateQueries("getDashboardDonations");
      queryClient.invalidateQueries("getDashboardGraph");
      queryClient.invalidateQueries("getDashboardGiftAid");
      queryClient.invalidateQueries("getDashboardDonationTypes");
      queryClient.invalidateQueries("getRefunds");
    },
  });
};

export const onEditDonationType = () => {
  const queryClient = useQueryClient();
  return useMutation(editDonationType, {
    onSuccess: () => {
      queryClient.invalidateQueries("getDonationTypes");
      queryClient.invalidateQueries("getDonationType");
    },
  });
};

export const onLogin = () => {
  const queryClient = useQueryClient();
  return useMutation(login, {
    onSuccess: () => {
      queryClient.invalidateQueries("getUser");
    },
  });
};

export const onRefund = () => {
  const queryClient = useQueryClient();
  return useMutation(refund, {
    onSuccess: () => {
      queryClient.invalidateQueries("getRefundHistory");
      queryClient.invalidateQueries("getDonations");
      queryClient.invalidateQueries("getDonors");
      queryClient.invalidateQueries("getDonorRecords");
      queryClient.invalidateQueries("getDonorsTransactions");
      queryClient.invalidateQueries("getDonors");
      queryClient.invalidateQueries("getDonationsSummary");
      queryClient.invalidateQueries("getOtherIncomeSummary");
      queryClient.invalidateQueries("getOtherIncome");
      queryClient.invalidateQueries("getRefundSummary");
      queryClient.invalidateQueries("getDonorsSummary");
      queryClient.invalidateQueries("getDonationTypes");
      queryClient.invalidateQueries("getDashboardDonors");
      queryClient.invalidateQueries("getDashboardDonations");
      queryClient.invalidateQueries("getDashboardGraph");
      queryClient.invalidateQueries("getDashboardGiftAid");
      queryClient.invalidateQueries("getDashboardDonationTypes");
      queryClient.invalidateQueries("getRefunds");
    },
  });
};

export const onChangePassword = () => {
  return useMutation(changePassword);
};

export const onChangeLoggedInPassword = () => {
  return useMutation(changeLoggedInPassword);
};

export const onResetPassword = () => {
  return useMutation(resetPassword);
};

export const onEditProfile = () => {
  const queryClient = useQueryClient();
  return useMutation(editProfile, {
    onSuccess: () => {
      queryClient.invalidateQueries("getUser");
    },
  });
};

export const onEditOrganization = () => {
  return useMutation(editOrganization);
};
export const onEditPlatform = () => {
  const queryClient = useQueryClient();
  return useMutation(editPlatform, {
    onSuccess: () => {
      queryClient.invalidateQueries("getUser");
    },
  });
};

export const onVerify = () => {
  return useMutation(verify);
};

export const requestOtp = () => {
  return useMutation(sendOtp);
};

export const validateOtp = () => {
  return useMutation(checkOtp);
};

//admin end points
export const getAdminDonnees = (query) => {
  return api.get(`/admin/donees${query ? `?${query}` : " "}`);
};

export const onGetAdminDonnees = (query) => {
  return useQuery(["getAdminDonnees", query], () => getAdminDonnees(query));
};

export const getAdminDoneeDetails = (query) => {
  return api.get(`/admin/donees/${query ? `${query}` : " "}`);
};

export const onGetAdminDonneeDetails = (query) => {
  return useQuery(["getAdminDonneeDetails", query], () =>
    getAdminDoneeDetails(query),
  );
};

export const getAdminDoneeAggregate = (query) => {
  return api.get(`/admin/donees/${query ? `${query}` : " "}/aggregate`);
};

export const onGetAdminDonneeAggregate = (query) => {
  return useQuery(["getAdminDonneeAggregate", query], () =>
    getAdminDoneeAggregate(query),
  );
};

export const adminLogin = (data) => {
  return api.post(`/admin/auth/login`, data);
};

export const onAdminLogin = () => {
  return useMutation(adminLogin);
};

export const getAdminDonors = (query) => {
  return api.get(`/admin/donors${query ? `?${query}` : " "}`);
};

export const onGetAdminDonors = (query) => {
  return useQuery(["getAdminDonors", query], () => getAdminDonors(query));
};

export const getAdminDonorDetails = (query) => {
  return api.get(`/admin/donors/${query ? `${query}` : " "}`);
};

export const onGetAdminDonorDetails = (query) => {
  return useQuery(["getAdminDonorDetails", query], () =>
    getAdminDonorDetails(query),
  );
};

export const getAdminDonorAggregate = (query) => {
  return api.get(`/admin/donors/${query ? `${query}` : " "}/aggregate`);
};

export const onGetAdminDonorAggregate = (query) => {
  return useQuery(["getAdminDonorAggregate", query], () =>
    getAdminDonorAggregate(query),
  );
};

export const adminSupport = (data) => {
  return api.post(`/admin/support`, data);
};

export const sendSupportMessage = () => {
  return useMutation(adminSupport);
};

export const exportCsv = (route, filter) => {
  return api.get(`${route}action=export&columns=${filter}`);
};

export const onExportCSV = (route, filter) => {
  return useQuery(["getExport", filter], () => exportCsv(route, filter), {
    enabled: false,
  });
};

export const exportGiftAidCsv = (route, filter) => {
  return api.get(`${route}?${filter}`);
};

export const onExportGiftAidsCSV = (route, filter) => {
  return useQuery(
    ["getGiftAidExport", filter],
    () => exportGiftAidCsv(route, filter),
    {
      enabled: false,
    },
  );
};
